import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlineStar } from "react-icons/md";
import axiosClient from "../../axios-client";

// const reports = [
//   {
//     id: 1,
//     title:
//       "Global Protein Purification And Isolation Market Outlook, 2023–2030",
//     category: "Telecom Media & Technology",
//     pdfUrl: "/reports/protein-purification-2023.pdf",
//     viewUrl: "/reports/view/protein-purification-2023",
//   },
//   {
//     id: 2,
//     title:
//       "Global Protein Purification And Isolation Market Outlook, 2023–2030",
//     category: "Telecom Media & Technology",
//     pdfUrl: "/reports/protein-purification-2023-2.pdf",
//     viewUrl: "/reports/view/protein-purification-2023-2",
//   },
//   {
//     id: 3,
//     title:
//       "Global Protein Purification And Isolation Market Outlook, 2023–2030",
//     category: "Telecom Media & Technology",
//     pdfUrl: "/reports/protein-purification-2023-3.pdf",
//     viewUrl: "/reports/view/protein-purification-2023-3",
//   },
//   {
//     id: 4,
//     title:
//       "Global Protein Purification And Isolation Market Outlook, 2023–2030",
//     category: "Telecom Media & Technology",
//     pdfUrl: "/reports/protein-purification-2023-4.pdf",
//     viewUrl: "/reports/view/protein-purification-2023-4",
//   },
//   {
//     id: 5,
//     title:
//       "Global Protein Purification And Isolation Market Outlook, 2023–2030",
//     category: "Telecom Media & Technology",
//     pdfUrl: "/reports/protein-purification-2023-5.pdf",
//     viewUrl: "/reports/view/protein-purification-2023-5",
//   },
//   {
//     id: 5,
//     title:
//       "Global Protein Purification And Isolation Market Outlook, 2023–2030",
//     category: "Telecom Media & Technology",
//     pdfUrl: "/reports/protein-purification-2023-5.pdf",
//     viewUrl: "/reports/view/protein-purification-2023-5",
//   },
//   {
//     id: 5,
//     title:
//       "Global Protein Purification And Isolation Market Outlook, 2023–2030",
//     category: "Telecom Media & Technology",
//     pdfUrl: "/reports/protein-purification-2023-5.pdf",
//     viewUrl: "/reports/view/protein-purification-2023-5",
//   },
//   {
//     id: 5,
//     title:
//       "Global Protein Purification And Isolation Market Outlook, 2023–2030",
//     category: "Telecom Media & Technology",
//     pdfUrl: "/reports/protein-purification-2023-5.pdf",
//     viewUrl: "/reports/view/protein-purification-2023-5",
//   },
//   {
//     id: 5,
//     title:
//       "Global Protein Purification And Isolation Market Outlook, 2023–2030",
//     category: "Telecom Media & Technology",
//     pdfUrl: "/reports/protein-purification-2023-5.pdf",
//     viewUrl: "/reports/view/protein-purification-2023-5",
//   },
//   {
//     id: 5,
//     title:
//       "Global Protein Purification And Isolation Market Outlook, 2023–2030",
//     category: "Telecom Media & Technology",
//     pdfUrl: "/reports/protein-purification-2023-5.pdf",
//     viewUrl: "/reports/view/protein-purification-2023-5",
//   },
//   {
//     id: 5,
//     title:
//       "Global Protein Purification And Isolation Market Outlook, 2023–2030",
//     category: "Telecom Media & Technology",
//     pdfUrl: "/reports/protein-purification-2023-5.pdf",
//     viewUrl: "/reports/view/protein-purification-2023-5",
//   },
// ];

const SavedReports = () => {
  
  const navigate = useNavigate();
  const userID = localStorage.getItem("userID");
  const [reportsData, setReportsData] = useState([]); // Default reports

  const [savedStates, setSavedStates] = useState(
    reportsData.reduce((acc, report) => ({ ...acc, [report.id]: true }), {})
  );

  const toggleSave = (reportId) => {
    setSavedStates((prev) => ({
      ...prev,
      [reportId]: !prev[reportId],
    }));
  };

  const handleViewReport = (viewUrl) => {
    window.open(viewUrl, "_blank", "noopener,noreferrer");
  };

  const handleDownloadReport = async (pdfUrl, title) => {
    try {
      const response = await fetch(pdfUrl);
      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${title}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading report:", error);
    }
  };

  useEffect(() => {
    const fetchSavedReports = async () => {
      try {
        // Fetch saved reports for the user
        const response = await axiosClient.get(`/users/saved/report/${userID}`);

        // Map the response to set reportsData with the correct data format
        const fetchedReports = response.data.savedReports.map((report) => ({
          id: report._id,
          reportTitle: report.reportTitle,
          category: report.category,
          pdfUrl: report.pdfUrl,
          viewUrl: report.viewUrl,
        }));

        // Set the reports data
        setReportsData(fetchedReports);

        // Initialize savedStates where each report ID is mapped to a boolean indicating if it is saved
        const savedReportIds = fetchedReports.map((report) => report.id);
        setSavedStates(
          savedReportIds.reduce((acc, reportId) => {
            acc[reportId] = true;
            return acc;
          }, {})
        );
      } catch (error) {
        console.error("Error fetching saved reports:", error);
      }
    };

    fetchSavedReports();
  }, [userID]); // Re-fetch if the userID changes (although this is unlikely to change in practice)


  return (
    <div className="px-4 sm:px-6 md:px-8 lg:px-10 py-6 sm:py-8 md:py-10">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 sm:gap-0 font-inter">
        <h2 className="text-2xl sm:text-3xl font-bold font4">Saved Reports</h2>
        <button
          className="text-[#34749b] text-sm sm:text-base underline underline-offset-2 hover:text-blue-500 font-medium"
          onClick={() => navigate("/saved-reports")}
        >
          See all
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-4 sm:mt-6">
      {reportsData.map((report) => (
          <div
            key={report._id}
            className="border rounded-2xl p-3 sm:p-4 box-saved hover:shadow-lg transition-shadow duration-300"
          >
            <div className="flex justify-between items-start gap-2">
              <div className="text-left flex-1">
                <h3 className="text-sm sm:text-base font-semibold font-poppins mb-1 line-clamp-2">
                {report.reportTitle || "No title available"}
                </h3>
                <p className="text-xs sm:text-sm font9 font-dmSans text-gray-600">
                  {report.category}
                </p>
              </div>
              <button
                onClick={() => toggleSave(report.id)}
                className="transition-colors duration-200 flex-shrink-0"
              >
                <MdOutlineStar
                  className={`w-6 h-6 sm:w-8 sm:h-7 ${
                    savedStates[report.id] ? "font2" : "text-gray-400"
                  }`}
                />
              </button>
            </div>

            <div className="mt-4 sm:mt-6 flex flex-col sm:flex-row gap-2 sm:gap-4">
              <button
                onClick={() => handleViewReport(report.viewUrl)}
                className="text-xs sm:text-sm font2 font-dmSans bg-lightPink px-3 sm:px-4 py-2 rounded-md hover:bg-pink-200 flex items-center justify-center sm:justify-start gap-1 w-full sm:w-auto"
              >
                <img
                  src="images/pink-repo.png"
                  alt="View"
                  className="w-4 h-4 sm:w-5 sm:h-5"
                />
                View Report
              </button>
              <button
                onClick={() =>
                  handleDownloadReport(report.pdfUrl, report.title)
                }
                className="text-xs sm:text-sm font2 font-dmSans font-medium text-white bg-pink px-3 sm:px-4 py-2 rounded-md flex items-center justify-center sm:justify-start gap-2 w-full sm:w-auto"
              >
                <img
                  src="images/download.png"
                  alt="Download"
                  className="w-3 h-3 sm:w-4 sm:h-4"
                />
                Download Report
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedReports;
